import { X } from 'lucide-react'
import { useCallback, useEffect, useRef, useState } from 'react'
import { cn } from '../lib/utils'

const DISPLAY_MS = 20_000
const EXIT_ANIM_MS = 500

export function ReviewedByBenPopup() {
  const [mounted, setMounted] = useState(true)
  const [closing, setClosing] = useState(false)
  const hidTimer = useRef<ReturnType<typeof setTimeout> | null>(null)
  const exitTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const beginClose = useCallback(() => {
    if (closing) return
    if (hidTimer.current) {
      window.clearTimeout(hidTimer.current)
      hidTimer.current = null
    }
    if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setMounted(false)
      return
    }
    setClosing(true)
  }, [closing])

  useEffect(() => {
    if (!mounted || closing) return

    hidTimer.current = window.setTimeout(() => {
      beginClose()
    }, DISPLAY_MS)

    return () => {
      if (hidTimer.current) window.clearTimeout(hidTimer.current)
    }
  }, [mounted, closing, beginClose])

  useEffect(() => {
    if (!closing) return

    exitTimer.current = window.setTimeout(() => {
      setMounted(false)
    }, EXIT_ANIM_MS)

    return () => {
      if (exitTimer.current) window.clearTimeout(exitTimer.current)
    }
  }, [closing])

  function dismiss() {
    beginClose()
  }

  if (!mounted) return null

  return (
    <aside
      aria-live="polite"
      className={cn(
        'fixed bottom-[7.5rem] right-5 z-[72] flex w-[min(calc(100vw-2.5rem),240px)] flex-col items-center [isolation:isolate]',
        closing ? 'reviewed-by-ben-stack-out' : 'reviewed-by-ben-stack-in',
      )}
    >
      <div className="relative z-0 -mb-12 flex h-36 w-[11.5rem] justify-center overflow-hidden">
        <img
          src="/bengg.png"
          alt=""
          className="pointer-events-none min-h-[118%] w-full max-w-none object-cover object-top drop-shadow-[0_10px_28px_rgba(0,0,0,0.5)]"
        />
      </div>
      <div className="reviewed-by-ben-card relative z-10 w-full border border-crusta-800/50 bg-[#080A0F]/95 px-4 pb-3.5 pt-3.5 text-center shadow-[0_-12px_32px_rgba(8,10,15,0.65)] backdrop-blur-xl">
        <div className="pointer-events-none absolute left-0 top-0 h-1 w-full bg-crusta-500" />
        <button
          type="button"
          aria-label="Close reviewed by message"
          onClick={dismiss}
          className="absolute right-2 top-2 border border-white/20 bg-white/5 p-1 text-white/70 transition hover:border-crusta-500/70 hover:text-white"
        >
          <X className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
        <p className="font-interactive pt-0.5 text-sm font-black uppercase tracking-[0.14em] text-white drop-shadow-[0_0_12px_rgba(0,245,255,0.25)]">
          Reviewed by Ben
        </p>
      </div>
    </aside>
  )
}
